export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";